export const withSiteMap = (url, siteMap) => {
    return url.replace('{SITE_MAP}', siteMap ? `${siteMap}.` : '');
};


// WEBPACK FOOTER //
// src/util/with-site-map.js